import { apiSlice } from '../api/apiSlice';
import { fetchWorldCitiesQueryFn } from '../api/fetchWorldCities';

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/user/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    logout: builder.mutation({
      query: (body) => ({
        url: '/user/logout',
        method: 'POST',
        body,
      }),
    }),
    getCurrentUser: builder.query({
      query: () => '/user/me',
    }),
    register: builder.mutation({
      query: (userData) => ({
        url: '/user',
        method: 'POST',
        body: userData,
      }),
    }),
    verifyEmail: builder.mutation({
      query: ({ otp, email }) => ({
        url: `/user/verifyEmail/${otp}/${email}`,
        method: 'PUT',
      }),
    }),
    resendOtp: builder.mutation({
      query: (emailData) => ({
        url: '/user/resendotp',
        method: 'POST',
        body: emailData,
      }),
    }),
    googleAuth: builder.mutation({
      query: (payload) => ({
        url: '/user/google',
        method: 'POST',
        body: payload,
      }),
    }),
    microsoftAuth: builder.mutation({
      query: (payload) => ({
        url: '/user/microsoft',
        method: 'POST',
        body: payload,
      }),
    }),
    getWorldCities: builder.query({
      // Plain fetch (no cookies) — required for DataHub CORS (* origin)
      queryFn: fetchWorldCitiesQueryFn,
      keepUnusedDataFor: 60 * 60,
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useVerifyEmailMutation,
  useResendOtpMutation,
  useGoogleAuthMutation,
  useMicrosoftAuthMutation,
  useGetWorldCitiesQuery,
  useLogoutMutation,
  useGetCurrentUserQuery,
} = authApiSlice;
